/**
 * Metrics
 */

$(function () {

	$('@metric').each(function () {

		var $metric = $(this);

		var properties = $metric.data('metric-properties') || {};
		properties.url = properties.url || location.pathname;

		switch ($metric.data('metric-event')) {

			case 'click':
				$metric.on('click', function () {
					twilio.analytics.event($metric.data('metric-label'), properties);
				});
				break;

			case 'pageview':
			default:
				twilio.analytics.event($metric.data('metric-label'), properties);
				break;

		}

	});

});
